import { useMemo } from 'react';

import { useBookmakersAll } from './useBookmakersAll';

export const useOffersSpecialAllCount = () => {
  const bookmakers = useBookmakersAll();

  return useMemo(
    () => bookmakers.reduce((total, cur) => total + (cur.offers.specialOffers || []).length, 0),
    [bookmakers],
  );
};
